import React from "react";
import NewsletterTwo from "../component/NewsletterTwo";

function NewsletterTwoContainers() {
  return <NewsletterTwo />;
}

export default NewsletterTwoContainers;
